import { Component, inject } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../core/services/auth.service';
import { User } from '../../../../core/models/auth.interface';

@Component({
  selector: 'app-admin-dashboard',
  imports: [
    CommonModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatToolbarModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslateModule
  ],
  templateUrl: './admin-dashboard.html',
  styleUrl: './admin-dashboard.css',
})
export class AdminDashboardComponent {
  authService = inject(AuthService);
  private translate = inject(TranslateService);

  sidenavOpened = true;
  suppliersMenuOpened = false;

  languages = [
    { code: 'ru', name: 'Русский' },
    { code: 'ky', name: 'Кыргызча' }
  ];

  toggleSidenav(): void {
    this.sidenavOpened = !this.sidenavOpened;
  }

  toggleSuppliersMenu(): void {
    this.suppliersMenuOpened = !this.suppliersMenuOpened;
  }

  getUserRole(user: User | null): string {
    if (!user) {
      return 'Пользователь';
    }

    // Проверяем clientRoles для agro_tariff_quota
    const roles = user.clientRoles?.['agro_tariff_quota'] || [];

    if (roles.length === 0) {
      return 'Пользователь';
    }

    // Берем первую роль
    const role = roles[0];
    const roleMap: Record<string, string> = {
      'quota_admin': 'Администратор',
      'quota_supplier': 'Поставщик',
      'quota_moderator': 'Модератор',
      'quota_operator': 'Оператор квот',
      'quota_manager': 'Менеджер квот',
      'quota_viewer': 'Наблюдатель'
    };
    return roleMap[role] || role;
  }

  onLogout(): void {
    this.authService.logout();
  }

  getCurrentLanguageName(): string {
    const currentLang = this.translate.currentLang || this.translate.defaultLang;
    const lang = this.languages.find(l => l.code === currentLang);
    return lang?.name || 'Русский';
  }

  changeLanguage(langCode: string): void {
    this.translate.use(langCode);
    localStorage.setItem('language', langCode);
  }
}
